var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#5AB464"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 29.3333H23.333C26.683 29.3333 27.283 27.9917 27.458 26.3583L28.083 19.6917C28.308 17.6583 27.7247 16 24.1664 16H15.833C12.2747 16 11.6914 17.6583 11.9164 19.6917L12.5414 26.3583C12.7164 27.9917 13.3164 29.3333 16.6664 29.3333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 15.9993V15.3327C16.667 13.8577 16.667 12.666 19.3337 12.666H20.667C23.3337 12.666 23.3337 13.8577 23.3337 15.3327V15.9993",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 21.8333V22.6667C21.6663 22.675 21.6663 22.675 21.6663 22.6833C21.6663 23.5917 21.658 24.3333 19.9997 24.3333C18.3497 24.3333 18.333 23.6 18.333 22.6917V21.8333C18.333 21 18.333 21 19.1663 21H20.833C21.6663 21 21.6663 21 21.6663 21.8333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.042 20.166C26.117 21.566 23.917 22.3993 21.667 22.6827",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1836 20.3926C14.0586 21.6759 16.1753 22.4509 18.3336 22.6926",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeIcon);
export default __webpack_public_path__ + "static/media/modeIcon.2ca98536102afaba86f18140ff85ed17.svg";
export { ForwardRef as ReactComponent };